import React from 'react';
import PropTypes from 'prop-types';
import { Box, Text } from 'grommet';
import { SimpleModal } from '@Components/Control';
import { StyledButton } from './VideoDetails';

const URLDetails = ({
  small,
  title,
  platform,
  primaryUrl,
  textColor = 'var(--page-modal-text)',
  buttonHighlight = 'var(--page-highlight)',
  fallbackHeader = 'Details',
  truncateAt = null,
}) => {
  const [showModal, setShowModal] = React.useState(false);

  const displayText = (() => {
    const raw = primaryUrl || fallbackHeader;
    if (truncateAt && raw.length > truncateAt) {
      return `${raw.slice(0, truncateAt - 1)}…`;
    }
    return raw;
  })();

  return (
    <Box>
      <StyledButton
        small={small}
        isOpen={showModal}
        onClick={() => setShowModal(true)}
      >
        <Text
          size={small ? '1rem' : '0.9rem'}
          weight={500}
          color="var(--button-table-text)"
          style={{ textDecoration: 'underline', wordBreak: truncateAt ? 'normal' : 'break-all', whiteSpace: truncateAt ? 'nowrap' : undefined }}
        >
          {displayText}
        </Text>
      </StyledButton>
      {showModal && (
        <SimpleModal
          hideLowerSection
          small={small}
          toggleModal={setShowModal}
          modalTitle={title || fallbackHeader}
          textColor={textColor}
          highlightColor={buttonHighlight}
          modalBg="var(--page-modal-bg)"
          titleSize="1.2rem"
          desktopMinWidth="30rem"
        >
          <Box direction="column" gap="0.75rem" pad={{ vertical: '0.5rem' }}>
            {title && (
              <Box direction="row" gap="0.5rem" align="center">
                <Text size="1rem" color={textColor} weight={500}>Title:</Text>
                <Text color={textColor} size="1rem">{title}</Text>
              </Box>
            )}
            {platform && (
              <Box direction="row" gap="0.5rem" align="center">
                <Text size="1rem" color={textColor} weight={500}>Platform:</Text>
                <Text color={textColor} size="1rem">{platform}</Text>
              </Box>
            )}
            <Box direction="row" gap="0.5rem" align="center">
              <Text size="1rem" color={textColor} weight={500}>URL:</Text>
              <a
                href={primaryUrl}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  color: buttonHighlight,
                  textDecoration: 'underline',
                  fontWeight: 600,
                  fontSize: '1rem',
                  wordBreak: 'break-all',
                }}
              >
                {primaryUrl}
              </a>
            </Box>
          </Box>
        </SimpleModal>
      )}
    </Box>
  );
};

URLDetails.propTypes = {
  small: PropTypes.bool,
  title: PropTypes.string,
  platform: PropTypes.string,
  primaryUrl: PropTypes.string,
  textColor: PropTypes.string,
  buttonHighlight: PropTypes.string,
  fallbackHeader: PropTypes.string,
  truncateAt: PropTypes.number,
};

export default URLDetails;
